import { Controller } from '@hotwired/stimulus'

export default class IntentionSliderController extends Controller {
  static targets = ['hiddenField']

  connect () {
    this.retryCount = 0
    this.maxRetries = 5
    this.initializeSlider()
  }

  initializeSlider () {
    const sliderElement = this.element.querySelector('.slider__content')

    if (sliderElement && sliderElement.noUiSlider) {
      sliderElement.noUiSlider.on('set', (values, handle) => {
        const value = parseInt(values[handle])
        this.hiddenFieldTarget.value = value
        this.submitForm()
      })
    } else if (this.retryCount < this.maxRetries) {
      this.retryCount++
      setTimeout(() => { this.initializeSlider() }, 150)
    }
  }

  submitForm () {
    const form = this.element.closest('form')
    form.requestSubmit()
  }
}
